import { CampaignContent } from 'schemas/Content.schema';

const AwarenessCampaignContent: CampaignContent = {
  type: 'Communication',
  name: 'Choose a campaign name',
  description: 'Choose a name that describes the communications campaign and is easy to understand. You could include the topic, communication type, and year.',
  example: "For example, 'Health Check reminders – 2025'.",
  startAndEndDateIntro: 'Choose the communications campaign start and end dates',
  startDateLabel: 'Communications start date',
  endDateLabel: 'Communications end date',
};

export default AwarenessCampaignContent;
